import { ResultStatus } from '../models/test-run.model';
import type { ResPillStatus } from '../components/res-pill/res-pill.component';

/**
 * Ergebnis-Status eines Laufs oder Durchlaufs auf die Pille abgebildet. res-pill
 * kennt alle sechs Werte inklusive `not-run` als eigenes Kind, sodass BLOCKED
 * nicht faelschlich rot als Fehler erscheint und SKIPPED ("Uebersprungen") und
 * NOT_RUN ("Nicht ausgefuehrt") ihre eigenen Pillen bekommen (sgraetz-Review
 * NEX-1086 C3 + Nachfassung).
 *
 * <p>Liegt hier und nicht in der Uebersicht, weil die Durchlaeufe-Zwischenebene
 * (NEX-1037) dieselbe Abbildung braucht — eine zweite Tabelle daneben koennte
 * davon abweichen.
 */
export const TEST_RUN_TO_RES_PILL: Record<ResultStatus, ResPillStatus> = {
  PASSED: 'passed',
  FAILED: 'failed',
  RUNNING: 'running',
  BLOCKED: 'blocked',
  SKIPPED: 'skipped',
  NOT_RUN: 'not-run',
};

/**
 * Ergebnis-Status als Material-Symbol. Liegt neben {@link TEST_RUN_TO_RES_PILL}, weil
 * Testlauf-Seite und Durchlauf-Runner dieselbe Abschluss-Karte zeigen — zwei Tabellen
 * koennten beim naechsten Statuswert auseinanderlaufen.
 */
export const TEST_RUN_STATUS_ICON: Record<ResultStatus, string> = {
  NOT_RUN: 'remove',
  RUNNING: 'play_arrow',
  PASSED: 'check',
  FAILED: 'close',
  BLOCKED: 'block',
  SKIPPED: 'skip_next',
};

export function deriveRunOutcome(statuses: readonly ResultStatus[]): ResultStatus {
  if (statuses.length === 0) return 'RUNNING';
  if (statuses.some((s) => s === 'FAILED')) return 'FAILED';
  if (statuses.some((s) => s === 'BLOCKED')) return 'BLOCKED';
  if (statuses.some(isOpenStatus)) return 'RUNNING';
  return statuses.some((s) => s === 'PASSED') ? 'PASSED' : 'SKIPPED';
}

/** Offen ist ein Ergebnis, das noch fehlt: noch nicht ausgefuehrt oder gerade laufend. */
export function isOpenStatus(status: ResultStatus): boolean {
  return status === 'NOT_RUN' || status === 'RUNNING';
}
